import { createContext } from 'react';

export type IHealthMonitorCtx = {
  logHeartbeatEvent: () => void;
};

export const KIOSK_HEARTBEAT_INTERVAL = 15 * 60 * 1000;

export const HealthMonitorContext = createContext({} as IHealthMonitorCtx);

export default HealthMonitorContext.Consumer;
